import React from 'react';
import { Divider, Tooltip, Typography } from '@mui/material';
import { Skeleton } from '@mui/material';
import { SERVICE_DOWN, SERVICE_DOWN_MESSAGE } from 'common/constants/valuations';
import { StatusCardProps } from './StatusCard.props';
import { classes, StyledPaper } from './StatusCard.styles';



const StatusCard = ({ isLoading = false, title, value }: StatusCardProps) => (
  <StyledPaper className={classes.card} data-testid={`value-card-${title}`}>
    <Typography className={classes.title} component="h2">
      {title}
    </Typography>
    <Divider className={classes.divider} />
    {isLoading ? (
      <Skeleton className={classes.skeleton} variant="text" />
    ) : (
      <Typography className={classes.value} paragraph>
        {value}
        {value === SERVICE_DOWN && (
          <Tooltip title={SERVICE_DOWN_MESSAGE} arrow>
            <span> ⚠️</span>
          </Tooltip>
        )}
      </Typography>
    )}
  </StyledPaper>
);

export default StatusCard;
